"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GalleryThemeArray = exports.GalleryThemeVariants = exports.BACKDROP_OFFSET = exports.GALLERY_SCRIPT = void 0;
var GALLERY_SITE_NAME = 'davidsbridalinc-xty3vn';
var GALLERY_SCRIPT = "var CRL8_SITENAME = '".concat(GALLERY_SITE_NAME, "';\n      !function(){var e=window.crl8=window.crl8||{},n=!1,i=[];e.ready=function(e){n?e():i.push(e)},e.pixel=e.pixel||function(){e.pixel.q.push(arguments)},e.pixel.q=e.pixel.q||[];var t=window.document,o=t.createElement(\"script\"),c=e.debug||-1!==t.location.search.indexOf(\"crl8-debug=true\")?\"js\":\"min.js\";o.async=!0,o.src=t.location.protocol+\"//edge.curalate.com/sites/\"+CRL8_SITENAME+\"/site/latest/site.\"+c,o.onload=function(){n=!0,i.forEach(function(e){e()})};var r=t.getElementsByTagName(\"script\")[0];r.parentNode.insertBefore(o,r.nextSibling)}();");
exports.GALLERY_SCRIPT = GALLERY_SCRIPT;
var BACKDROP_OFFSET = 500;
exports.BACKDROP_OFFSET = BACKDROP_OFFSET;
var GalleryThemeVariants;
exports.GalleryThemeVariants = GalleryThemeVariants;

(function (GalleryThemeVariants) {
  GalleryThemeVariants["WHITE"] = "white";
  GalleryThemeVariants["SEASHELL"] = "seashell";
  GalleryThemeVariants["SEASHELL_CROPPED"] = "seashell-cropped";
  GalleryThemeVariants["MOCASSIN"] = "mocassin";
  GalleryThemeVariants["MOCASSIN_CROPPED"] = "mocassin-cropped";
  GalleryThemeVariants["CLARET"] = "claret";
  GalleryThemeVariants["CLARET_CROPPED"] = "claret-cropped";
  GalleryThemeVariants["BLACK"] = "black";
  GalleryThemeVariants["BLACK_CROPPED"] = "black-cropped";
})(GalleryThemeVariants || (exports.GalleryThemeVariants = GalleryThemeVariants = {}));

var GalleryThemeArray = Object.values(GalleryThemeVariants);
exports.GalleryThemeArray = GalleryThemeArray;